<template>
  <div class="mobile-page">
    <img :src="require('@/assets/images/mobile-page.jpg')" alt="">
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>
.mobile-page {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    height: auto;
  }
}
</style>